export default __webpack_public_path__ + "static/media/landscape9.9a7a7e4a.JPG";